import axios from "axios";
import { getApiBaseUrl } from "../config/api";

export interface Holiday {
  date: string;
  name: string;
  type: string;
  color?: string;
}

class HolidayService {
  private baseURL: string;

  constructor() {
    // Use centralized API configuration
    this.baseURL = getApiBaseUrl();
  }

  private getAuthToken(): string {
    return localStorage.getItem("authToken") || "";
  }

  /**
   * Get holidays for a specific month
   */
  async getHolidaysForMonth(year: number, month: number): Promise<Holiday[]> {
    try {
      const response = await axios.get(
        `${this.baseURL}/holidays/month/${year}/${month}`,
        {
          headers: {
            Authorization: `Bearer ${this.getAuthToken()}`,
          },
        }
      );
      return response.data.holidays || [];
    } catch (error) {
      console.error("Failed to fetch holidays for month:", error);
      return [];
    }
  }

  /**
   * Check if a specific date is a holiday
   */
  async isHoliday(date: string): Promise<Holiday | null> {
    try {
      const response = await axios.get(
        `${this.baseURL}/holidays/date/${date}`,
        {
          headers: {
            Authorization: `Bearer ${this.getAuthToken()}`,
          },
        }
      );
      return response.data.holiday || null;
    } catch (error) {
      console.error("Failed to check holiday:", error);
      return null;
    }
  }

  /**
   * Get holidays for a date range
   */
  async getHolidaysForRange(
    startDate: string,
    endDate: string
  ): Promise<Holiday[]> {
    try {
      const response = await axios.get(
        `${this.baseURL}/holidays/range?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${this.getAuthToken()}`,
          },
        }
      );
      return response.data.holidays || [];
    } catch (error) {
      console.error("Failed to fetch holidays for range:", error);
      return [];
    }
  }
}

export const holidayService = new HolidayService();
